module.exports = __webpack_public_path__ + "img/side-safety.a824cd44.svg";